import React from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import "./FloatingContactButtons.css";

const FloatingContactButtons = () => {
  return (
    <div className="floating-contact">
      <a
        href="tel:0509348007"
        className="floating-btn call-btn"
        aria-label="Call SG Office"
      >
        <FaPhoneAlt />
      </a>

      <a
        href="https://wa.me/971509348007?text=Hi%20SG%20Office%2C%20I%20would%20like%20to%20enquire%20about%20your%20products."
        className="floating-btn whatsapp-btn"
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp SG Office"
      >
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default FloatingContactButtons;